
import {DevFunction, FunctionObject, getString, ObjectObject} from
  "../../interpreting/ScriptInterpreter.js";



export const toString = new DevFunction(
  "toString", {typeArr: ["any?", "any?"]},
  ({callerNode, execEnv}, [val, getSourceCode]) => {
    return getString(val, callerNode, execEnv, getSourceCode);
  }
);

export const at = new DevFunction(
  "at", {typeArr: ["string", "integer"]}, ({}, [str, ind]) => {
    return str.at(ind);
  }
);

export const substring = new DevFunction(
  "substring", {typeArr: ["string", "integer", "integer?"]},
  ({}, [str, start, end]) => {
    return str.substring(start, end);
  }
);

export const slice = new DevFunction(
  "slice", {typeArr: ["string", "integer", "integer?"]},
  ({}, [str, start, end]) => {
    return str.slice(start, end);
  }
);

export const indexOf = new DevFunction(
  "indexOf", {typeArr: ["string", "string", "integer?"]},
  ({}, [str, needle, position]) => {
    return str.indexOf(needle, position);
  }
);

export const repeat = new DevFunction(
  "repeat", {typeArr: ["string", "integer unsigned"]}, ({}, [str, count]) => {
    return str.repeat(count);
  }
);

export const split = new DevFunction(
  "split", {typeArr: ["string", "string", "integer unsigned?"]},
  ({}, [str, separator, limit]) => {
    return str.split(separator, limit);
  }
);

export const join = new DevFunction(
  "join", {typeArr: ["array", "string?"]},
  ({callerNode, execEnv}, [arr, separator]) => {
    if (arr instanceof ObjectObject) arr = arr.members;
    return arr.map(val => getString(val, callerNode, execEnv)).join(separator);
  }
);


export const toUpperCase = new DevFunction(
  "toUpperCase", {typeArr: ["string"]}, ({}, [str]) => {
    return str.toUpperCase();
  }
);

export const toLowerCase = new DevFunction(
  "toLowerCase", {typeArr: ["string"]}, ({}, [str]) => {
    return str.toLowerCase();
  }
);

export const trim = new DevFunction(
  "trim", {typeArr: ["string"]}, ({}, [str]) => {
    return str.trim();
  }
);

export const replace = new DevFunction(
  "replace", {typeArr: ["string", "string", "any"]},
  ({callerNode, execEnv, interpreter}, [str, pattern, replacement]) => {
    if (replacement instanceof FunctionObject) {
      replacement = (match) => interpreter.executeFunction(
        replacement, [match], callerNode, execEnv
      );
    } else {
      replacement = getString(replacement, callerNode, execEnv);
    }
    return str.replace(pattern, replacement);
  }
);

export const replaceAll = new DevFunction(
  "replaceAll", {typeArr: ["string", "string", "any"]},
  ({callerNode, execEnv, interpreter}, [str, pattern, replacement]) => {
    if (replacement instanceof FunctionObject) {
      replacement = (match) => interpreter.executeFunction(
        replacement, [match], callerNode, execEnv
      );
    } else {
      replacement = getString(replacement, callerNode, execEnv);
    }
    return str.replaceAll(pattern, replacement);
  }
);


// TODO: Continue implementing all other standard String methods, except RegEx-
// related ones, since RegExes should only be implemented at a later point and
// in another dev lib, where we then need to make sure to prevent exponential
// runtimes (and to calculate/estimate a fitting compGas cost).